import { RefObject, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  continueProcessing,
  requestFinteqHub,
  setPreprocessorStatus,
} from '@cashier/cashier-data-access';
import {
  LeaderIframeMessages,
  PaymentMethodInput,
} from '@cashier/cashier-model';

import { selectProcessingAttributes } from '../selectors';

interface UseLeaderIframeMessagesParams {
  iframeRef: RefObject<HTMLIFrameElement>;
  onLeaderMessage?: (payload: { fields: PaymentMethodInput[] }) => void;
}

export const useLeaderIframeMessages = ({
  iframeRef,
  onLeaderMessage,
}: UseLeaderIframeMessagesParams): void => {
  const dispatch = useDispatch();
  const paymentAttributes = useSelector(selectProcessingAttributes);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const iframeWindow = iframeRef.current?.contentWindow;
      if (!iframeWindow || event.source !== iframeWindow) return;

      const { data } = event;

      if (data?.type === LeaderIframeMessages.FieldsDataToCashier) {
        onLeaderMessage(data.payload);
      }

      if (data?.type === LeaderIframeMessages.FieldsDataToProcessingRequest) {
        const mergedPaymentAttributes = {
          ...paymentAttributes,
          ...data.payload,
        };

        dispatch(continueProcessing({ ...mergedPaymentAttributes }));
      }

      if (data?.type === LeaderIframeMessages.PliromyTokenizer) {
        const mergedPaymentAttributes = {
          ...paymentAttributes,
          ...data.payload,
        };
        dispatch(continueProcessing({ ...mergedPaymentAttributes }));
      }

      if (data?.type === LeaderIframeMessages.FinteqHubPaymentProcessed) {
        dispatch(requestFinteqHub(data.payload));
      }
      if (data?.type === LeaderIframeMessages.PreprocessorLoaded) {
        dispatch(setPreprocessorStatus(data.payload));
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onLeaderMessage, iframeRef, dispatch, paymentAttributes]);
};
